




















































































































































































import QErrors from "@/common/qErrors.vue";
import _cloneDeep from "lodash/cloneDeep";
import { Component, Vue } from "vue-property-decorator";
import QNotify from "@/common/qNotify";
import productApi from "@/api/productApi";
import Product, { Category, MasterProduct } from "@/model/product";
import categoryApi from "@/api/categoryApi";
import SaleBomList from "@/common/saleBomList.vue";
import fileApi from "@/api/fileApi";
import Image from "@/model/image";
import { compareWithKeys } from "@/common/utils";

@Component({
  name: "ProductEdit",
  components: {
    QErrors,
    SaleBomList,
  },
})
export default class ProductEdit extends Vue {
  public form: Product = new Product();
  public formInit: Product = new Product();
  public productClone: Product;
  public isEdit = false;
  public errors: any = {};
  public errors_item_cartons = [];
  public isShow = false;
  public categories: Category[] = [];


  public confirmCancel(): void {
    if (this.isChanged()) {
      this.$modal.showCancel({
        text: `${this.$t("common.cancel_message", {
          name: this.form.itemName
        })}`,
        confirmText: `${this.$t("common.message.cancel_button")}`,
        onConfirm: () => {
          this.isShow = false;
        },
      });
    } else {
      this.isShow = false;
    }
  }

  get getItemCode() {
    if (this.form.master_product) {
      return this.form.master_product.item_code;
    }
    return null;
  }

  handleFileUpload(event) {
    this.errors = { ...this.errors, file: [] };
    try {
      let file = event.target.files[0];
      let formData = new FormData();
      formData.append("file", file);
      fileApi.add(formData).then((response) => {
        if (response.meta.status == 200) {
          this.form.m_cart_image = new Image(response.data);
          this.form.cart_item_image = this.form.m_cart_image.id;
        } else {
          this.errors = { ...this.errors, ...response.meta.errors };
        }
      });
    } catch (error) {
      console.log(error.messages);
    }
  }

  removeFile() {
    this.form.cart_item_image = null;
    this.form.m_cart_image = null;
    (this.$refs.inputFile as HTMLInputElement).value = null;
  }

  async remove() {
    this.$modal.showDelete({
      text: `${this.form.itemName} を削除します。この操作は取り消せません。`,
      confirmClass: "mb__add-color-red",
      onConfirm: async () => {
        const result = await productApi.delete(this.productClone.item_code);
        if (result.meta.status != 200) {
          QNotify.error({
            text: result.meta.message,
          });
        } else {
          QNotify.success({
            text: this.$t("product_page.messsage.deleted"),
          });
          this.isShow = false;
          this.$emit("change");
        }
      },
    });
  }

  async submit(): Promise<void> {
    this.errors = {};
    let result;
    if (this.isEdit) {
      result = await productApi.edit(this.productClone.item_code, this.form);
    } else {
      result = await productApi.addNew(this.form);
    }
    if (result.meta.status != 200) {
      this.errors = result.meta.errors;
      QNotify.error({
        text: result.meta.message,
      });
    } else {
      QNotify.success({
        text: this.$t(
          this.isEdit
            ? "product_page.messsage.updated"
            : "product_page.messsage.created"
        ),
      });
      this.$emit("change");
      this.isShow = false;
    }
  }

  public async show(product: Product = null) {
    this.$el.querySelector(".mb__popup-contents").scrollTop = 0;
    if (product && product.item_code) {
      this.productClone = product;
      this.isEdit = true;
      this.form = await productApi.getDetail(product.item_code);
    } else {
      this.isEdit = false;
      this.form = new Product();
      this.form.status = 1;
      this.removeFile();
    }
    this.formInit = _cloneDeep(this.form)
    this.isShow = true;
    this.errors = {};
    this.categories = await categoryApi.getCategory();
  }

  public async findMasterProduct() {
    this.form.master_product = null;
    Vue.delete(this.errors, "item_code");
    if (!this.form.item_code) return;

    const result = await productApi.getMasterProduct(this.form.item_code);
    if (result.meta.errors) {
      if (result.meta.status == '422') {
        this.errors = result.meta.errors;
      } else {
        QNotify.error({
          text: result.meta.message,
        });
      }
    } else {
      console.log("RESULT", result);
      this.form.master_product = new MasterProduct(result.data);
      this.form.item_code = this.form.master_product.item_code;
    }
  }

  public isChanged() {
    return compareWithKeys(this.form, this.formInit, [
      'item_code',
      'cart_cate_code',
      'cart_item_discription',
      'cart_item_image',
      'status',
    ])
  }
}
